import { useEffect, useMemo, useState } from 'react';
import { FiSearch, FiUsers, FiPlus } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import SectionCard from '../../components/ui/SectionCard';
import ListItem from '../../components/ui/ListItem';
import EmptyState from '../../components/ui/EmptyState';
import { getUsers } from '../../services/userService';
import { ROLE_LABELS } from '../../models/roles';
import { getInitials } from '../../utils/format';

export default function UsersView() {
  const [users, setUsers] = useState(null);
  const [query, setQuery] = useState('');

  useEffect(() => {
    let active = true;
    getUsers().then((data) => {
      if (active) setUsers(data);
    });
    return () => {
      active = false;
    };
  }, []);

  const filtered = useMemo(() => {
    if (!users) return [];
    const q = query.trim().toLowerCase();
    if (!q) return users;
    return users.filter(
      (u) => u.name.toLowerCase().includes(q) || u.username.toLowerCase().includes(q)
    );
  }, [users, query]);

  return (
    <DashboardLayout title="Usuarios" subtitle={`${users?.length ?? 0} en el sistema`}>
      <div className="search-box">
        <FiSearch aria-hidden="true" />
        <input
          placeholder="Buscar por nombre o usuario"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Buscar usuarios"
        />
      </div>

      <button type="button" className="btn btn-outline btn-block" disabled>
        <FiPlus /> Nuevo usuario <span className="badge-soft">Pronto</span>
      </button>

      <SectionCard title="Equipo">
        {users === null && <EmptyState icon={<FiUsers />} title="Cargando usuarios…" />}
        {users !== null && filtered.length === 0 && (
          <EmptyState icon={<FiUsers />} title="Sin resultados" description="No encontramos usuarios con ese criterio." />
        )}
        {filtered.map((u) => (
          <ListItem
            key={u.id}
            icon={<span className="avatar-icon">{getInitials(u.name)}</span>}
            title={u.name}
            meta={
              <>
                <span className="pill">{ROLE_LABELS[u.role]}</span>
                {!u.active && <span className="status-badge status-badge--muted">Inactivo</span>}
              </>
            }
          />
        ))}
      </SectionCard>
    </DashboardLayout>
  );
}
